
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-87ef3e74&scoped=true!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ShowMore.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ShowMore.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-87ef3e74!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ShowMore.vue"),
  /* scopeId */
  "data-v-87ef3e74",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShowMore.vue
// module id = 1117
// module chunks = 1